<script setup lang="ts">

</script>

<template>

<div class="flex items-center text-navy-900 font-medium dark:text-white">
    <img src="/assets/media/logos/icon-blue-pink.svg" alt="Insight logo" class="h-8 w-8 mr-2" />
    <span class="hidden lg:inline text-surface-200">BBMS Insights</span>&nbsp;
    <span class="hidden lg:inline inline-flex items-center rounded-md dark:bg-surface-600 bg-surface-100 ml-2 px-2 py-1 text-xs font-medium text-surface-600 dark:text-surface-0 ring-1 ring-inset ring-surface-500/10">BETA</span>
</div>

</template>